// import { Mic, MicOff } from 'lucide-react'
// import React, { useEffect, useState } from 'react'
// import { RetellWebClient } from 'retell-client-js-sdk'
// import env from '../../config/configuration'
// import Layout from '../Layout'
// import { useAgent } from './agent.context'
// import ChatContainer from './chat'

// const retellWebClient = new RetellWebClient()

// export default function Web() {
//   const { loading: loadingAgent, agent } = useAgent()
//   const [chat, setChat] = useState([])
//   const [isCalling, setIsCalling] = useState(false)
//   const [loading, setLoading] = useState(false)
//   const [error, setError] = useState(null)

//   const createWebCall = async () => {
//     try {
//       const response = await fetch(
//         'https://api.retellai.com/v2/create-web-call',
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${env.RETELL_API}`,
//           },
//           body: JSON.stringify({ agent_id: agent.agent_id }),
//         }
//       )

//       if (!response.ok) {
//         throw new Error('Network response was not ok')
//       }

//       const data = await response.json()
//       console.log('Web call created successfully:', data)
//       return data
//     } catch (err) {
//       setError(err.message)
//       console.error('Error creating web call:', err)
//     } finally {
//       setLoading(false)
//     }
//   }

//   const toggleConversation = async (e) => {
//     e.preventDefault()
//     setLoading(true)
//     setError(null)
//     if (isCalling) {
//       retellWebClient.stopCall()
//       setLoading(false)
//       setIsCalling(false)
//     } else {
//       const registerCallResponse = await createWebCall()
//       if (registerCallResponse.access_token) {
//         retellWebClient
//           .startCall({
//             accessToken: registerCallResponse.access_token,
//           })
//           .catch(console.error)
//         setIsCalling(true) // Update button to "Stop" when conversation starts
//         setLoading(false)
//       }
//     }
//   }

//   // Initialize the SDK
//   const initRetellSDK = () => {
//     retellWebClient.on('call_started', () => {
//       console.log('call started')
//     })

//     retellWebClient.on('call_ended', () => {
//       console.log('call ended')
//       setIsCalling(false)
//     })

//     // When agent starts talking for the utterance
//     // useful for animation
//     retellWebClient.on('agent_start_talking', () => {
//       console.log('agent_start_talking')
//     })

//     // When agent is done talking for the utterance
//     // useful for animation
//     retellWebClient.on('agent_stop_talking', () => {
//       console.log('agent_stop_talking')
//     })

//     // Real time pcm audio bytes being played back, in format of Float32Array
//     // only available when emitRawAudioSamples is true
//     retellWebClient.on('audio', (audio) => {
//       // console.log(audio);
//     })

//     // Update message such as transcript
//     // You can get transcrit with update.transcript
//     // Please note that transcript only contains last 5 sentences to avoid the payload being too large
//     retellWebClient.on('update', (update) => {
//       console.log('Update', update)
//       const transcript = update.transcript.map((item) => {
//         return {
//           type: item.role == 'agent' ? 'bot' : 'user',
//           message: item.content,
//         }
//       })
//       setChat(transcript)
//     })

//     retellWebClient.on('metadata', (metadata) => {
//       // console.log(metadata)
//     })

//     retellWebClient.on('error', (error) => {
//       console.error('An error occurred:', error)
//       // Stop the call
//       retellWebClient.stopCall()
//     })
//   }

//   const onLoad = () => {
//     initRetellSDK()
//   }

//   useEffect(onLoad, [])

//   return (
//     <Layout>
//       <div className='max-w-7xl mx-auto'>
//         <div className='flex justify-center items-center h-[calc(100vh-330px)] flex-col'>
//           <div className='grid md:grid-cols-2 items-end gap-12'>
//             <div className='min-h-[360px] flex items-end flex-col'>
//               <div className='w-full'>
//                 <button
//                   type='submit'
//                   onClick={toggleConversation}
//                   className={`w-full border ${
//                     loadingAgent && !agent
//                       ? 'opacity-60 cursor-not-allowed'
//                       : 'hover:from-[#065EDA] hover:to-[#054CA8]'
//                   } border-white py-3 font-semibold rounded-full transition duration-300 bg-gradient-to-b from-[#0874E2] to-[#065EDA] text-white flex items-center justify-center gap-2`}
//                   disabled={loadingAgent && !agent}
//                 >
//                   {loading ? (
//                     <>Processing...</>
//                   ) : (
//                     <>{isCalling ? <MicOff size={20} /> : <Mic size={20} />}</>
//                   )}
//                 </button>
//               </div>
//             </div>

//             <div className='hidden md:block'>
//               <ChatContainer chat={chat} />
//             </div>
//           </div>
//         </div>
//       </div>
//     </Layout>
//   )
// }


import { Mic, MicOff } from 'lucide-react'
import React, { useEffect, useRef, useState } from 'react'
import { RetellWebClient } from 'retell-client-js-sdk'
import env from '../../config/configuration'
import Layout from '../Layout'
import { useAgent } from './agent.context'
import ChatContainer from './chat'

function CircleDisplay({ isAgentTalking }) {
  const canvasRef = useRef(null)
  const animationRef = useRef(null)
  const pulseData = useRef([
    { size: 0, direction: 1, speed: 0.6 },  // Center circle
    { size: 0, direction: 1, speed: 0.4 },  // Middle circle
    { size: 0, direction: 1, speed: 0.3 }   // Outer circle
  ])
  const lastTalkTime = useRef(0)
  
  const drawCircles = () => {
    const canvas = canvasRef.current
    if (!canvas) return
    
    const ctx = canvas.getContext('2d')
    if (!ctx) return
    
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    
    const dpr = window.devicePixelRatio || 1
    const centerX = (canvas.width / dpr) / 2
    const centerY = (canvas.height / dpr) / 2
    const time = Date.now()
    
    if (isAgentTalking) {
      lastTalkTime.current = time
      
      pulseData.current.forEach((pulse, index) => {
        pulse.size += (pulse.speed * pulse.direction)
        
        if (pulse.size > 15 + (index * 5) || pulse.size < 0) {
          pulse.direction *= -1
          pulse.size = Math.max(0, pulse.size)
        }
      })
    } else {
      const timeSinceLastTalk = time - lastTalkTime.current
      const decayFactor = Math.min(1, timeSinceLastTalk / 1000)
      
      pulseData.current.forEach(pulse => {
        if (pulse.size > 0) {
          pulse.size = Math.max(0, pulse.size - (pulse.speed * decayFactor))
        }
      })
    }
    
    const baseRadius = 190
    
    // Outer ring
    ctx.beginPath()
    ctx.arc(centerX, centerY, baseRadius + pulseData.current[2].size * 0.3, 0, Math.PI * 2)
    ctx.strokeStyle = `rgba(6, 94, 218, ${0.5 + pulseData.current[2].size * 0.02})`
    ctx.lineWidth = 2
    ctx.stroke()
    
    // Middle ring
    ctx.beginPath()
    ctx.arc(centerX, centerY, baseRadius * 0.66 + pulseData.current[1].size * 0.5, 0, Math.PI * 2)
    ctx.strokeStyle = `rgba(8, 116, 226, ${0.7 + pulseData.current[1].size * 0.02})`
    ctx.lineWidth = 3
    ctx.stroke()
    
    // Inner ring (changed from filled circle to ring)
    ctx.beginPath()
    ctx.arc(centerX, centerY, baseRadius * 0.33 + pulseData.current[0].size, 0, Math.PI * 2)
    ctx.strokeStyle = `rgba(8, 116, 226, ${0.9 + pulseData.current[0].size * 0.02})`
    ctx.lineWidth = 4  // Thicker line for inner ring
    ctx.stroke()
  }
  
  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    
    const size = 400
    const dpr = window.devicePixelRatio || 1
    
    canvas.width = size * dpr
    canvas.height = size * dpr
    canvas.style.width = `${size}px`
    canvas.style.height = `${size}px`
    
    const ctx = canvas.getContext('2d')
    ctx.scale(dpr, dpr)
    
    const animate = () => {
      drawCircles()
      animationRef.current = requestAnimationFrame(animate)
    }
    
    animationRef.current = requestAnimationFrame(animate)
    
    return () => {
      cancelAnimationFrame(animationRef.current)
    }
  }, [isAgentTalking])
  
  return (
    <canvas 
      ref={canvasRef} 
      className="w-full max-w-xs mx-auto" 
      style={{ 
        aspectRatio: '1', 
        display: 'block',
        marginBottom: '5px',
      }} 
    />
  )
}

const retellWebClient = new RetellWebClient()

export default function Web() {
  const { loading: loadingAgent, agent } = useAgent()
  const [chat, setChat] = useState([])
  const [isCalling, setIsCalling] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [isAgentTalking, setIsAgentTalking] = useState(false)

  const createWebCall = async () => {
    try {
      const response = await fetch(
        'https://api.retellai.com/v2/create-web-call',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${env.RETELL_API}`,
          },
          body: JSON.stringify({ agent_id: agent.agent_id }),
        }
      )

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const data = await response.json()
      console.log('Web call created successfully:', data)
      return data
    } catch (err) {
      setError(err.message)
      console.error('Error creating web call:', err)
    } finally {
      setLoading(false)
    }
  }

  const toggleConversation = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    if (isCalling) {
      retellWebClient.stopCall()
      setLoading(false)
      setIsCalling(false)
    } else {
      const registerCallResponse = await createWebCall()
      if (registerCallResponse.access_token) {
        retellWebClient
          .startCall({
            accessToken: registerCallResponse.access_token,
          })
          .catch(console.error)
        setIsCalling(true)
        setLoading(false)
      }
    }
  }

  const initRetellSDK = () => {
    retellWebClient.on('call_started', () => {
      console.log('call started')
    })

    retellWebClient.on('call_ended', () => {
      console.log('call ended')
      setIsCalling(false)
      setIsAgentTalking(false)
    })

    retellWebClient.on('agent_start_talking', () => {
      console.log('agent_start_talking')
      setIsAgentTalking(true)
    })

    retellWebClient.on('agent_stop_talking', () => {
      console.log('agent_stop_talking')
      setIsAgentTalking(false)
    })

    retellWebClient.on('audio', (audio) => {
      // Audio data could be used for more precise visualizations
    })

    retellWebClient.on('update', (update) => {
      console.log('Update', update)
      const transcript = update.transcript.map((item) => {
        return {
          type: item.role == 'agent' ? 'bot' : 'user',
          message: item.content,
        }
      })
      setChat(transcript)
    })

    retellWebClient.on('metadata', (metadata) => {
      console.log(metadata)
    })

    retellWebClient.on('error', (error) => {
      console.error('An error occurred:', error)
      retellWebClient.stopCall()
      setIsAgentTalking(false)
    })
  }

  const onLoad = () => {
    initRetellSDK()
  }

  useEffect(onLoad, [])

  return (
    <Layout>
      <div className='max-w-7xl mx-auto'>
        <div className='flex justify-center items-center h-[calc(100vh-330px)] flex-col'>
          <div className='grid md:grid-cols-2 items-end gap-12'>
            <div className='min-h-[360px] flex flex-col justify-between'>
              <div className='flex-grow flex items-center justify-center'>
                <CircleDisplay isAgentTalking={isAgentTalking} />
              </div>
              
              <div className='w-full'>
                <button
                  type='submit'
                  onClick={toggleConversation}
                  className={`w-[200px] justify-self-center border ${
                    loadingAgent && !agent
                      ? 'opacity-60 cursor-not-allowed'
                      : 'hover:from-[#065EDA] hover:to-[#054CA8]'
                  } border-white py-3 font-semibold rounded-full transition duration-300 bg-gradient-to-b from-[#0874E2] to-[#065EDA] text-white flex items-center justify-center gap-2`}
                  disabled={loadingAgent && !agent}
                >
                  {loading ? (
                    <>Processing...</>
                  ) : (
                    <>
                      {isCalling ? <MicOff size={20} /> : <Mic size={20} />}
                      {isCalling ? 'End Call' : 'Talk'}
                    </>
                  )}
                </button>
                {error && <p className="text-red-500 mt-2 text-center">{error}</p>}
              </div>
            </div>

            <div className='hidden md:block'>
              <ChatContainer chat={chat} />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
